import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import Subnavigation from 'components/Subnavigation';
// utils
import { FormattedMessage } from 'react-intl';
import OfflineScreen from 'components/OfflineScreen/OfflineScreen';

const subNavLinks = [
  {
    label: <FormattedMessage id="general.apiMonitoring.pushResults" />,
    link: '/monitoring/amino/pushresults',
  },
];

const AminoHome = ({ isOnline, children }) => (
  <div className="BarnsheetsHome clearfix">
    <Subnavigation isSticky links={subNavLinks} className="small-12 column" />
    {isOnline ? (
      <div className="small-12 column">{children}</div>
    ) : (
      <OfflineScreen />
    )}
  </div>
);

AminoHome.propTypes = {
  children: T.object.isRequired,
  isOnline: T.bool,
};

export default connect((state) => ({
  isOnline: state.network.isOnline,
  active: state.dataTable.amino.meta.active,
}))(AminoHome);
